'use strict';

var React = require('react');

const EphemeralPresenceManagerContext = /*#__PURE__*/React.createContext(undefined);

exports.EphemeralPresenceManagerContext = EphemeralPresenceManagerContext;
